<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px; align-items: center;">
				<b-col sm="2">
					<b-input-group size="sm">
						<date-picker
							class="full-width"
							v-model="fromDate"
							lang="ru"
							:placeholder="$t('certificate.fromDate')"
							value-type="format"
							format="DD-MM-YYYY"
						/>
					</b-input-group>
				</b-col>
				<b-col sm="2">
					<b-input-group size="sm">
						<date-picker
							class="full-width"
							v-model="toDate"
							lang="ru"
							:placeholder="$t('certificate.toDate')"
							value-type="format"
							format="DD-MM-YYYY"
						/>
					</b-input-group>
				</b-col>
				<b-col sm="2">
					<multiselect
						v-model="selectedDepartment"
						:options="departments"
						:multiple="false"
						track-by="id"
						label="name"
						:show-labels="false"
						:allow-empty="false"
						:placeholder="$t('pricing.department')"
						class="multiselect-pricing"
						@input="onDepartmentChange"
					>
						<span slot="noResult">Oops! No elements found.</span>
					</multiselect>
				</b-col>
				<b-col sm="2">
					<multiselect
						v-model="selectedPaymentType"
						:options="paymentTypeList"
						:multiple="false"
						track-by="id"
						label="name"
						:show-labels="false"
						:allow-empty="true"
						placeholder="Тип оплаты"
						class="multiselect-pricing"
					>
						<span slot="noResult">Oops! No elements found.</span>
					</multiselect>
				</b-col>
				<b-col sm="4">
					<b-button @click="getItems" variant="dark" class="mr-2" :disabled="loading">
						<b-spinner v-if="loading" small class="mr-1" />
						<i v-else class="fa fa-search mr-1"></i>
						<span>Поиск</span>
					</b-button>
					<b-button @click="print" variant="outline-dark" class="mr-2" title="Печать">
						<i class="fa fa-print"></i>
					</b-button>
					<b-button
						v-if="items.length > 0"
						@click="excelExport1('gridContainer', 'Отчет продажи по валютам за период')"
						variant="success"
						class="mr-2"
						:disabled="loading"
					>
						<i class="fa fa-file-excel-o mr-1"></i> {{ $t('excel-export.download-excel') }}
					</b-button>
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting" style="font-size: 25px;">
							<b-button class="fa fa-th" variant="dark" style="padding: 8px; width: 40px; height: 38px;" title="Колонки"></b-button>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown" style="max-height: 400px; overflow-y: auto;">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ ind.label }}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<span v-if="items.length > 0" class="badge badge-info p-2" style="font-size: 13px;">
						Всего чеков: {{ items.length }}
					</span>
				</b-col>
			</b-row>
			<hr class="mt-1" />
		</div>

		<b-card-body class="marginPage" id="print_certificate">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px; font-weight: bold;">Central Asia Megastar</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6>
						<b>Отчет продажи по валютам за период {{ $t("c") }} {{ fromDate ? fromDate : '________' }} {{ $t("po") }} {{ toDate ? toDate : '________' }}</b>
					</h6>
				</b-col>
				<b-col cols="3" class="text-right">
					<span v-if="selectedDepartment"><b>{{ $t('pricing.department') }}:</b> {{ selectedDepartment.name }}</span>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<b-table
						:items="items"
						id="gridContainer"
						:fields="computedFields"
						:busy="loading"
						:responsive="true"
						small
						bordered
						show-empty
						striped
						hover
						foot-clone
						no-footer-sorting
					>
						<template #table-busy>
							<div class="text-center my-3">
								<b-spinner small class="mr-2" /><strong>Загрузка...</strong>
							</div>
						</template>

						<template #empty>
							<div class="text-center my-2"><b>{{ $t('empty') }}</b></div>
						</template>

						<template #cell(index)="data">
							{{ data.index + 1 }}
						</template>

						<template #cell(saleNumber)="data">
							<b>{{ data.item.saleNumber }}</b>
						</template>

						<template #cell(saleDate)="data">
							{{ data.item.saleDate }}
						</template>

						<template #cell(cashboxName)="data">
							{{ data.item.cashboxName }}
						</template>

						<template #cell(status)="data">
							<b-badge :variant="data.item.action === 'QAYTARISH' ? 'danger' : 'success'">
								{{ data.item.status }}
							</b-badge>
						</template>

						<template #cell(summa)="data">
							<b>{{ data.item.summa | currencyFormat }}</b>
						</template>

						<template #cell(Sale_in_EUR)="data">
							<span v-if="data.item.Sale_in_EUR > 0">{{ data.item.Sale_in_EUR | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_USD)="data">
							<span v-if="data.item.Sale_in_USD > 0">{{ data.item.Sale_in_USD | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_RUB)="data">
							<span v-if="data.item.Sale_in_RUB > 0">{{ data.item.Sale_in_RUB | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_GBP)="data">
							<span v-if="data.item.Sale_in_GBP > 0">{{ data.item.Sale_in_GBP | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_CNY)="data">
							<span v-if="data.item.Sale_in_CNY > 0">{{ data.item.Sale_in_CNY | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_UZS)="data">
							<span v-if="data.item.Sale_in_UZS > 0">{{ data.item.Sale_in_UZS | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_VISA)="data">
							<span v-if="data.item.Sale_in_VISA > 0">{{ data.item.Sale_in_VISA | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_HUMO)="data">
							<span v-if="data.item.Sale_in_HUMO > 0">{{ data.item.Sale_in_HUMO | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_UZCARD)="data">
							<span v-if="data.item.Sale_in_UZCARD > 0">{{ data.item.Sale_in_UZCARD | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_UZUM)="data">
							<span v-if="data.item.Sale_in_UZUM > 0">{{ data.item.Sale_in_UZUM | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_OSON)="data">
							<span v-if="data.item.Sale_in_OSON > 0">{{ data.item.Sale_in_OSON | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_CLICK)="data">
							<span v-if="data.item.Sale_in_CLICK > 0">{{ data.item.Sale_in_CLICK | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_PAYME)="data">
							<span v-if="data.item.Sale_in_PAYME > 0">{{ data.item.Sale_in_PAYME | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_ONE_QR)="data">
							<span v-if="data.item.Sale_in_ONE_QR > 0">{{ data.item.Sale_in_ONE_QR | currencyFormat }}</span>
						</template>

						<template #cell(Sale_in_PAYNET)="data">
							<span v-if="data.item.Sale_in_PAYNET > 0">{{ data.item.Sale_in_PAYNET | currencyFormat }}</span>
						</template>

						<!-- Footer Totals -->
						<template #foot(index)>{{ "" }}</template>
						<template #foot(saleNumber)>{{ "" }}</template>
						<template #foot(saleDate)>{{ "" }}</template>
						<template #foot(cashboxName)>{{ "" }}</template>
						<template #foot(status)>
							<b>{{ $t("Itogo") }}</b>
						</template>
						<template #foot(summa)>
							<b>{{ sumTotalSum | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_EUR)>
							<b>{{ sumSaleInEUR | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_USD)>
							<b>{{ sumSaleInUSD | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_RUB)>
							<b>{{ sumSaleInRUB | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_GBP)>
							<b>{{ sumSaleInGBP | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_CNY)>
							<b>{{ sumSaleInCNY | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_UZS)>
							<b>{{ sumSaleInUZS | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_VISA)>
							<b>{{ sumSaleInVISA | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_HUMO)>
							<b>{{ sumSaleInHUMO | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_UZCARD)>
							<b>{{ sumSaleInUZCARD | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_UZUM)>
							<b>{{ sumSaleInUZUM | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_OSON)>
							<b>{{ sumSaleInOSON | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_CLICK)>
							<b>{{ sumSaleInCLICK | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_PAYME)>
							<b>{{ sumSaleInPAYME | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_ONE_QR)>
							<b>{{ sumSaleInONEQR | currencyFormat }}</b>
						</template>
						<template #foot(Sale_in_PAYNET)>
							<b>{{ sumSaleInPAYNET | currencyFormat }}</b>
						</template>
					</b-table>

					<b-button
						v-if="items.length > 0"
						class="float-right mt-2 mb-3 hidden-print"
						@click="excelExport1('gridContainer', 'Отчет продажи по валютам за период')"
						variant="success"
						:disabled="loading"
					>
						<i class="fa fa-file-excel-o mr-1"></i> {{ $t('excel-export.download-excel') }}
					</b-button>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { BTable, VBTable } from 'bootstrap-vue';
import UsersService from '../../../services/users.sevice';
import ApiService from '../../../services/api.service';
import { TokenService } from '../../../services/storage.service';
import ReportService from '../../analytics/otchot/report.service';

export default {
	name: 'ReportSalesByCurrency',
	components: { Multiselect, BTable },
	directives: { VBTable },
	filters: {
		currencyFormat(val) {
			if (!val && val !== 0) return '';
			return Number(parseFloat(val)).toLocaleString('ru-RU', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		}
	},
	data() {
		return {
			items: [],
			fromDate: null,
			toDate: null,
			departments: [],
			selectedDepartment: null,
			cashboxList: [],
			selectedCashbox: null,
			paymentTypeList: [],
			selectedPaymentType: null,
			checkStatus: null,
			saleNumber: '',
			loading: false,
			fields: [
				{ key: 'index', label: '№', class: 'text-center', visible: true },
				{ key: 'saleNumber', label: 'Номер чека', class: 'text-center', visible: true, sortable: true },
				{ key: 'saleDate', label: 'Дата продажи', class: 'text-center', visible: true, sortable: true },
				{ key: 'cashboxName', label: 'Касса', class: 'text-center', visible: true, sortable: true },
				{ key: 'status', label: 'Статус', class: 'text-center', visible: true, sortable: true },
				{ key: 'summa', label: 'Сумма', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_EUR', label: 'Наличные EUR', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_USD', label: 'Наличные USD', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_RUB', label: 'Наличные RUB', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_GBP', label: 'Наличные GBP', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_CNY', label: 'Наличные CNY', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_UZS', label: 'Наличные UZS', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_VISA', label: 'VISA', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_HUMO', label: 'HUMO', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_UZCARD', label: 'UZCARD', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_UZUM', label: 'UZUM', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_OSON', label: 'OSON', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_CLICK', label: 'CLICK', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_PAYME', label: 'PAYME', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_ONE_QR', label: 'ONE_QR', class: 'text-right', visible: true, sortable: true },
				{ key: 'Sale_in_PAYNET', label: 'PAYNET', class: 'text-right', visible: true, sortable: true }
			]
		};
	},
	computed: {
		computedFields() {
			return this.fields.filter(f => f.visible);
		},
		sumTotalSum() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.summa) || 0), 0);
		},
		sumSaleInEUR() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_EUR) || 0), 0);
		},
		sumSaleInUSD() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_USD) || 0), 0);
		},
		sumSaleInRUB() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_RUB) || 0), 0);
		},
		sumSaleInGBP() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_GBP) || 0), 0);
		},
		sumSaleInCNY() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_CNY) || 0), 0);
		},
		sumSaleInUZS() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_UZS) || 0), 0);
		},
		sumSaleInVISA() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_VISA) || 0), 0);
		},
		sumSaleInHUMO() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_HUMO) || 0), 0);
		},
		sumSaleInUZCARD() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_UZCARD) || 0), 0);
		},
		sumSaleInUZUM() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_UZUM) || 0), 0);
		},
		sumSaleInOSON() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_OSON) || 0), 0);
		},
		sumSaleInCLICK() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_CLICK) || 0), 0);
		},
		sumSaleInPAYME() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_PAYME) || 0), 0);
		},
		sumSaleInONEQR() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_ONE_QR) || 0), 0);
		},
		sumSaleInPAYNET() {
			return this.items.reduce((acc, curr) => acc + (Number(curr.Sale_in_PAYNET) || 0), 0);
		}
	},
	created() {
		this.initDates();
		this.getDeps();
		this.fetchPaymentTypeList();
	},
	methods: {
		initDates() {
			const today = new Date();
			const dd = String(today.getDate()).padStart(2, '0');
			const mm = String(today.getMonth() + 1).padStart(2, '0');
			const yyyy = today.getFullYear();
			this.fromDate = `${dd}-${mm}-${yyyy}`;
			this.toDate = `${dd}-${mm}-${yyyy}`;
		},
		async getDeps() {
			try {
				const response = await UsersService.getPermittedDepartments(TokenService.getCurrentUserId());
				this.departments = response.data.permittedDepartments || [];
				if (this.departments.length > 0) {
					this.selectedDepartment = this.departments[0];
					this.onDepartmentChange();
				}
			} catch (e) {
				console.error(e);
			}
		},
		onDepartmentChange() {
			this.cashboxList = [];
			this.selectedCashbox = null;
			if (this.selectedDepartment) {
				ApiService.get(`cashbox/get/by-dep-id/${this.selectedDepartment.id}`)
					.then(res => {
						this.cashboxList = res.data || [];
					})
					.catch(err => {
						console.error(err);
					});
			}
		},
		async fetchPaymentTypeList() {
			try {
				const res = await ApiService.get(`references/BANK_CARD/list`);
				this.paymentTypeList = [
					{
						id: 60,
						name: 'Наличными',
						code: 'CASH',
						paymentTypeCode: 'CASH',
						paymentTypeId: 60
					},
					...(res.data || [])
				];
			} catch (err) {
				console.error(err);
			}
		},
		async getItems() {
			if (!this.selectedDepartment) {
				this.$vs.notify({
					text: 'Выберите подразделение',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				return;
			}
			if (!this.fromDate || !this.toDate) {
				this.$vs.notify({
					text: 'Выберите период',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				return;
			}

			this.loading = true;
			this.items = [];

			const payload = {
				depId: this.selectedDepartment.id,
				startDate: this.fromDate,
				endDate: this.toDate,
				cashboxId: this.selectedCashbox ? this.selectedCashbox.id : null,
				paymentTypeId: this.selectedPaymentType ? this.selectedPaymentType.id : null,
				saleNumber: this.saleNumber || null,
				action: this.checkStatus || null
			};

			try {
				const res = await ReportService.getReportSalesByCurrency(payload);
				this.items = res.data || [];
				this.loading = false;
				if (this.items.length === 0) {
					this.$vs.notify({
						text: 'По заданным фильтрам продажи не найдены',
						color: 'primary',
						icon: 'info',
						position: 'top-right'
					});
				}
			} catch (e) {
				this.loading = false;
				this.$vs.notify({
					title: e.message || 'Ошибка загрузки',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		excelExport1(tableID, filename = 'Отчет') {
			const uri = 'data:application/vnd.ms-excel;base64,';
			const template =
				'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
			const base64 = function(s) {
				return window.btoa(unescape(encodeURIComponent(s)));
			};
			const format = function(s, c) {
				return s.replace(/{(\w+)}/g, function(m, p) {
					return c[p];
				});
			};
			const toExcel = document.getElementById(tableID).innerHTML;
			const ctx = {
				worksheet: filename || '',
				table: toExcel
			};
			const link = document.createElement('a');
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx));
			link.click();
		},
		print() {
			const prtHtml = document.getElementById('print_certificate').innerHTML;
			let stylesHtml = '';
			for (let node of document.querySelectorAll('link[rel="stylesheet"], style')) {
				stylesHtml += node.outerHTML;
			}
			const WinPrint = window.open('', '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0');
			const html = `<!DOCTYPE html>
				<html>
					<head>
						<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
						<style>
							body { color: #000 !important; align-items: flex-start; padding: 20px; }
							#print_certificate { display: block; }
							table, tr, td, th { border: rgba(0,0,255,0.25) solid 1px !important; }
							table { border-collapse: collapse !important; width: 100%; font-size: 11px; }
							th, td { padding: 4px 6px; }
							.hidden-print { display: none !important; }
						</style>
						${stylesHtml}
					</head>
					<body>
						${prtHtml}
					</body>
				</html>`;
			WinPrint.document.write(html);
			WinPrint.document.close();
			WinPrint.focus();
			WinPrint.print();
		}
	}
};
</script>

<style scoped>
.full-width {
	width: 100%;
}
.multiselect-pricing {
	min-height: 38px;
}
.columns-dropdown {
	padding: 10px 15px;
}
</style>
